import styled from "@emotion/styled";
import { Toys } from "@mui/icons-material";
import { Container, Typography } from "@mui/material";
import {Grid} from "@mui/material";

const MainContainer = styled(Container)`
    background-image:url("./assets/About-bg.png");
    background-size:auto;
    background-position:center center;
    background-repeat:no-repeat;
    margin-top:50px;
    @media (max-width: 600px){
        background-size:contain;
    }
`
const Heading = styled(Typography)`
    font-family: 'ManjariBold';
    font-size: 60px;
    color: #2A3382;
    font-weight: 900;    
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(./assets/aboutheadingbg.png);
    padding: 60px 50px;
    @media (max-width:767px){
        font-size:40px;
        padding: 40px 40px 0px 40px;
    }
`
const P = styled(Typography)`
    color:#27233A;
    font-family:SegoeRegular;
    font-size:15;
    text-align:center;
`
const WrapperGrid = styled(Grid)`
    display:flex;
    justify-content:center;
    flex-direction:column;
    align-items:center;
`
const LinksWrapper = styled.a`
    color:#2A3382;
    font-family:ManjariBold;
    text-decoration:none;
    font-size:18px;
    margin:0px 10px;
    display: flex;
    align-items: center;
`
const LinksGrid = styled(Grid)`
    @media(min-width: 767px){
        margin-top:80px;
        align-items:center;
        justify-content:center;
        display:flex;
    }
`
const HeadingWrapper = styled.div`
    /* background-mage:; */
`
const LinksContainer = styled(Grid)`

`

export default function About(){
    return(
        <MainContainer id="chart">
            <WrapperGrid container spacing={2}>
                <Grid item xs={12}>
                    <HeadingWrapper>
                    <Heading variant="h1">About me</Heading>
                    </HeadingWrapper>
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                    <P>Woof! I'm Shih Tzu, a cryptocurrency project inspired by my adorable breed.
                         Just like us Shih Tzus, known for our intelligence and companionship,
                         I aim to bring joy, loyalty, and prosperity to my community of holders.</P>
                </Grid>
                <Grid item xs={12}  sm={10} md={8}>
                    <P>With the help of my amazing team, we're using advanced technology to create a strong
                         and resilient ecosystem. We want to ensure trust, security, and financial empowerment for all my holders.
                         Through blockchain and smart contracts, we make sure every transaction is transparent and efficient.</P>
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                    <P>I'm more than just a token; I'm a community-driven project with a big heart.
                         Together with my humans, we're working towards sustainable growth and long-term value.
                          We invite you to join our pack,
                         explore new possibilities, and embark on an exciting journey of financial freedom and growth.</P>
                </Grid>
                <Grid item xs={12} sm={10} md={8}>
                    <P>So, let's wag our tails and dive into this adventure together!
                         Bark with me and let Shih Tzu be the 
                        paw-some symbol of trust and prosperity in the world of cryptocurrency.</P>
                </Grid>
            </WrapperGrid>
            <LinksContainer container>
                <LinksGrid item xs={12}>
                    <LinksWrapper><img src="./assets/eth.png" alt=""/>BaseScan</LinksWrapper>
                    <LinksWrapper><img src="./assets/uni.png" alt=""/>Uniswap</LinksWrapper>
                    <LinksWrapper><img src="./assets/dexi.png" alt=""/>DexTools</LinksWrapper>
                </LinksGrid>
            </LinksContainer>
        </MainContainer>
    );
}